export default __webpack_public_path__ + "static/media/Micrah - Cyberpunk.a8f4a99a.mp3";